import { debounce } from 'throttle-debounce'

class Navigation {
  constructor(element) {
    this.header = element
    this.toggleBtn = this.header.querySelector('.header__toggle')
    this.isOpen = false

    this.toggle = this.toggle.bind(this)

    this.init()
  }

  toggle(e) {
    e.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.header.classList.add('header--open')
    this.isOpen = true
  }

  close() {
    this.header.classList.remove('header--open')
    this.isOpen = false
  }

  init() {
    this.toggleBtn.addEventListener('click', debounce(200, this.toggle))
  }
}

const navInit = {
  init() {
    const elements = document.querySelectorAll('.header')
    Array.from(elements).map(element => new Navigation(element))
  },
}

export default navInit
